













































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class TicketComponent extends Vue {
  @Prop({ required: true }) ticket!: any;

  get isBonus(): boolean {
    // A ticket is a bonus ticket if it doesn't have a ticket relation or it's not purchased
    return !this.ticket.purchased;
  }

  get isActive(): boolean {
    return this.ticket.is_active;
  }

  formatDate(dateString: string): string {
    if (!dateString) return '無期限';
    const date = new Date(dateString);
    return date.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  }

  formatPrice(price: number): string {
    return price ? `¥${price.toLocaleString()}` : '無料';
  }

  getStatusText(ticket: any): string {
    // Bonus tickets are always valid
    if (this.isBonus) return '有効';

    if (typeof this.isActive !== 'undefined') {
      return this.isActive ? '有効' : '期限切れ';
    }
  }

  getStatusColor(ticket: any): string {
    // Bonus tickets are always green (success)
    if (this.isBonus) return 'success';

    if (typeof this.isActive !== 'undefined') {
      return this.isActive ? 'success' : 'error';
    }
  }
}
